import {
  COPILOT_PLATFORM,
  COPILOT_AUTH_BASE_URL,
  COPILOT_AUTH_ENDPOINTS,
  COPILOT_THEME,
  COPILOT_ENV,
  COPILOT_ASSEMBLY_ID,
  COPILOT_WORKFLOW_ID,
  COPILOT_STARTER_PROMPTS,
} from '@assembly/constants'

export function initCopilot(): void {
  if (!window.AssemblyCopilot) {
    console.error('AssemblyCopilot script not loaded')
    return
  }

  window.AssemblyCopilot.init({
    platform: COPILOT_PLATFORM,
    environment: COPILOT_ENV,
    theme: COPILOT_THEME,
    auth: {
      baseUrl: COPILOT_AUTH_BASE_URL,
      endpoints: COPILOT_AUTH_ENDPOINTS,
    },
    starterPrompts: COPILOT_STARTER_PROMPTS,
  })

  if (COPILOT_ASSEMBLY_ID && COPILOT_WORKFLOW_ID) {
    window.assemblyCopilot?.setContext(COPILOT_ASSEMBLY_ID, COPILOT_WORKFLOW_ID)
  } else if (COPILOT_ASSEMBLY_ID) {
    window.assemblyCopilot?.setAssemblyId(COPILOT_ASSEMBLY_ID)
  } else if (COPILOT_WORKFLOW_ID) {
    window.assemblyCopilot?.setWorkflowId(COPILOT_WORKFLOW_ID)
  }

  console.log('[Copilot] Context set:', {
    assemblyId: COPILOT_ASSEMBLY_ID,
    workflowId: COPILOT_WORKFLOW_ID,
    instanceAvailable: !!window.assemblyCopilot,
  })
}
